export { SchoolIntegrationsPage } from './SchoolIntegrationsPage'
